import { createEntityAdapter } from '@ngrx/entity';

import { OrderHistoryItem } from '../../models';

function selectOrderId(order: OrderHistoryItem): string {
  return order.orderId;
}

export const orderHistoryAdapter = createEntityAdapter<OrderHistoryItem>({
  selectId: selectOrderId,
  sortComparer: false,
});
